module.exports = "/_next/static/images/638b44e8778f9859e62f2d2efac52ae6-xpeers.jpg";